/**
 * Funkcioni për të llogaritur distancën ndërmjet dy pikave gjeografike
 * Përdor formulën e Haversine për të llogaritur distancën më të shkurtër sipërfaqësore
 * mes dy pikave në sipërfaqen e tokës
 * 
 * @param {number} lat1 - Gjerësia gjeografike e pikës së parë (në gradë)
 * @param {number} lon1 - Gjatësia gjeografike e pikës së parë (në gradë)
 * @param {number} lat2 - Gjerësia gjeografike e pikës së dytë (në gradë)
 * @param {number} lon2 - Gjatësia gjeografike e pikës së dytë (në gradë)
 * @returns {number} Distanca në kilometra
 */
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  if (!lat1 || !lon1 || !lat2 || !lon2) {
    return null;
  }

  // Konvertimi nga string në numër (nëse është e nevojshme)
  lat1 = Number(lat1);
  lon1 = Number(lon1);
  lat2 = Number(lat2);
  lon2 = Number(lon2);

  // Konvertimi nga gradë në radianë
  const toRadians = (degree) => degree * (Math.PI / 180);
  
  const R = 6371; // Rrezja e Tokës në kilometra
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  
  // Formula e Haversine
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  const distance = R * c; // Distanca në kilometra
  
  // Kthejë distancën me 2 shifra pas presjes dhjetore
  return Math.round(distance * 100) / 100;
};

/**
 * Funksioni për të shtuar distancën nga qendra e qytetit për çdo hotel
 * 
 * @param {Array} hotels - Lista e hoteleve që do të përpunohet
 * @param {number} cityLat - Gjerësia gjeografike e qendrës së qytetit
 * @param {number} cityLng - Gjatësia gjeografike e qendrës së qytetit
 * @returns {Array} Lista e hoteleve me distancën e shtuar
 */
export const addDistanceToHotels = (hotels, cityLat, cityLng) => {
  if (!Array.isArray(hotels) || hotels.length === 0 || !cityLat || !cityLng) {
    return hotels;
  }

  return hotels.map(hotel => {
    const hotelLat = hotel.geolocation?.latitude;
    const hotelLng = hotel.geolocation?.longitude;
    
    const distanceFromCenter = calculateDistance(
      cityLat, 
      cityLng, 
      hotelLat, 
      hotelLng
    );
    
    return {
      ...hotel,
      distanceFromCenter: distanceFromCenter
    };
  });
}; 